<template>
  <v-app >
    <div>
      <v-alert
      class ="mx-auto"
       v-if = "showWarning"
       max-width="400"
       type="warning"> {{ textWarning }}  </v-alert>
      <v-alert
        class ="mx-auto"
        v-if = "showSuccess"
        max-width="500"
        type="success"> Recibirá la nueva contraseña en su casilla de correo. </v-alert>
    </div>
    <v-card class = "mx-auto"
      :min-width="400" :min-heigth="400">
      <v-card-title>Iniciar sesión</v-card-title>
      <v-card-text v-on:keyup.enter = "enter()">
        <v-select
          :items = "itemsEntidades"
          item-text = "nombre"
          item-value = "codigo"
          label = "Seleccione tipo de entidad"
          v-on:change = "getNombres"
        ></v-select>
        <v-select
          :items = "itemsNombres"
          item-text = "nombre"
          item-value = "codigo"
          label = "Seleccione entidad"
          v-on:change = "nombreSel"
        ></v-select>
        <v-text-field
          v-model="usuario"
          label="Usuario"></v-text-field>
        <v-text-field
          v-if ="!showRec"
          v-model="password"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Contraseña"
          hint="Minimo 8 caracteres"
          @click:append="show1 = !show1"></v-text-field>
      </v-card-text>
      <v-card-actions  class ="justify-center">
        <v-row v-if="!showRec">
          <v-col md = "6">
            <v-btn text small @click="showRec = true">Olvidé mi contraseña</v-btn>
          </v-col>
          <v-col md = "6" align = "right">
            <v-btn medium elevation = "5" color ="#51D6CC" @click="login()">Ingresar</v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col md = "6">
            <v-btn text small @click = "showRec = false">Cancelar</v-btn>
          </v-col>
          <v-col md = "6" align = "right">
            <v-btn medium elevation = "5" color ="#51D6CC" @click ="cambiarContraseña()">Enviar email</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-app>
</template>
<script>
import axios from 'axios';
import { url } from '@/variables';

export default {
  data() {
    return {
      show1: false,
      showWarning: false,
      showSuccess: false,
      showRec: false,
      usuario: '',
      password: '',
      itemsEntidades: [{ nombre: 'No hay datos', codigo: 0 }],
      itemsNombres: [{ nombre: 'No hay datos', codigo: 0 }],
      tipoSelected: 0,
      nombreSelected: 0,
      exito: false,
      reglasE: [
        v => !!v || 'El email es obligatorio.',
        v => /.+@.+\..+/.test(v) || 'El email debe ser válido.',
      ],
      warning: false,
      textWarning: '',
      text: 'Hay campos vacíos',
    };
  },
  methods: {
    init() {
      const path = `${url}/getEntidades`;
      axios.get(path)
        .then((response) => {
          if (response.status === 200) {
            this.itemsEntidades = response.data.entidades;
          }
        });
    },
    enter() {
      (this.showRec) ? this.cambiarContraseña() : this.login();
    },
    getNombres(opcion) {
      this.tipoSelected = opcion;
      if (opcion === 3) this.itemsNombres = [{ nombre: 'Asociación Argentina de arbitros', codigo: 0 }];
      else {
        const path = `${url}/getNombres`;
        axios.post(path, {
          tipo: opcion,
        })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.nombres.length > 0) this.itemsNombres = response.data.nombres;
              else {
                this.itemsNombres = [{ nombre: 'No hay datos', codigo: 0 }];
              }
            }
          });
      }
    },
    nombreSel(opcion) {
      this.nombreSelected = opcion;
    },
    camposVaciosLogin() {
      if (this.usuario === '' || this.password === '' || this.tipoSelected === 0) {
        return true;
      }
      return false;
    },
    login() {
      if (this.camposVaciosLogin()) {
        this.text = 'Hay campos vacíos';
        this.warning = true;
      } else {
        const path = `${url}/login`;
        axios.post(path, {
          user: this.usuario,
          pass: this.password,
          tipoCuenta: this.tipoSelected,
          codCuenta: this.nombreSelected,
        })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.msg === 'Ok') {
                this.$session.set('id', response.data.result[0]);
                this.$session.set('token', response.data.token);
                this.$session.set('temp', response.data.esTemp);
                this.$session.set('codCuenta', this.nombreSelected);
                this.$router.push('/cuentaCorriente');
                this.$router.go(0);
              } else {
                this.textWarning = response.data.msg;
                this.showWarning = true;
              }
            }
          })
          .catch(() => {

          });
      }
    },
    cambiarContraseña() {
      if (this.usuario == '' || this.codCuenta == '0') {
        this.textWarning = 'Hay campos vacíos';
        this.showWarning = true;
      } else {
        const path = `${url}/cambioPass`;
        axios.post(path, {
          user: this.usuario,
          codCuenta: this.nombreSelected,
        })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.msg === 'Ok') {
                this.showSuccess = true;
              }
              else{
                this.showWarning = true;
                this.textWarning = response.data.msg;
              }
            }
          });
        this.showRec = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
